import { Box, Typography } from "@mui/material";

const SegmentedControl = ({
    options,
    value,
    onChange
}) => {
    return (
        <Box
            sx={{
                display: "flex",
                p: 0.5,
                borderRadius: "14px",
                bgcolor: "#F4F7F9",
                border: "1px solid rgba(0,48,73,0.10)",
                mb: 1
            }}
        >
            {options.map((option) => {
                const selected = value === option.value;
                const Icon = option.icon;

                return (
                    <Box
                        key={option.value}
                        onClick={() => onChange(option.value)}
                        sx={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 0.8,
                            py: 1,
                            borderRadius: selected ? "50px" : "10px",
                            cursor: "pointer",
                            transition: "all .25s ease",

                            color: selected ? "#fff" : "#4B5563",

                            background: selected
                                ? "linear-gradient(180deg, #16B8EE 0%, #04A5E2 100%)"
                                : "transparent",


                            boxShadow: selected
                                ? "0 6px 16px rgba(0,48,73,0.22)"
                                : "none",

                            "&:hover": {
                                background: selected
                                    ? "linear-gradient(180deg, #16B8EE 0%, #04A5E2 100%)"
                                    : "rgba(15,95,127,0.08)"
                            }
                        }}
                    >
                        <Icon
                            sx={{
                                fontSize: 20,
                                color: selected ? "#fff" : "#6B7280",
                                transition: ".2s"
                            }}
                        />

                        <Typography
                            sx={{
                                fontSize: 13,
                                fontWeight: selected ? 700 : 600,
                                color: selected ? "#fff" : "#4B5563",
                                transition: ".2s"
                            }}
                        >
                            {option.label}
                        </Typography>
                    </Box>
                );
            })}
        </Box>
    );
};

export default SegmentedControl;